import $ from 'jquery';

const checkIfUndefined = value => typeof value === 'undefined';

const getInputValue = ($input) => {
  const { value, placeholder } = $input[0].attributes;
  const hasDefaultValue = checkIfUndefined(value) && !checkIfUndefined(placeholder);
  let inputValue = $input.val();
  if (inputValue === '' && hasDefaultValue) {
    inputValue = placeholder.value;
  }

  return inputValue;
};

const filterFieldsNotEmpty = (input) => {
  const $input = $(input);
  const inputValue = getInputValue($input);
  return (!/^(?:checkbox|radio)$/.test(input.type) || $input.prop('checked')) && inputValue !== '';
};

const prepareFilter = (input) => {
  const $input = $(input);
  const filter = {
    field: $input.attr('name'),
    value: getInputValue($input),
    comparator: $input.data('comparator') || 'eq',
  };
  // use the dropdown value for field instead of the <select> name
  if ($input.hasClass('js-filter-set-value-as-field')) {
    filter.field = filter.value;
    filter.value = $input.find(':selected').data('value') || 1;
  }
  // Add fallback data value to filters if it exists (ie: pass annual_fee as fallback if annual_fee_first is null)
  if ($input.data('fallback')) {
    filter.fallback = $input.data('fallback');
  }
  return filter;
};

/**
 * Get form filter data
 *
 * @param $filterForm
 * @returns {*}
 */
function getFormFilters($filterForm) {
  const $notDisableFields = $filterForm.find('[name]:not(disabled)');
  return $notDisableFields
    .filter((idx, input) => filterFieldsNotEmpty(input))
    .map((idx, input) => prepareFilter(input))
    .get();
}

/**
 * Updates form field values above table
 *
 * @param formAboveTable - either calculator form or filter form
 * @param fieldValues - { field, value, comparitor }
 */
function updateFormAboveTable(formAboveTable, fieldValues) {
  fieldValues.forEach((fieldValue) => {
    const { field, value } = fieldValue;
    const $field = $(formAboveTable).find(`[name="${field}"]`);
    if ($field.length) {
      $field[0].value = value;
    }
  });
}

export default {
  getFormFilters,
  updateFormAboveTable,
};
